import { render, staticRenderFns } from "./PriorityClients.vue?vue&type=template&id=4277b548&"
import script from "./PriorityClients.vue?vue&type=script&lang=js&"
export * from "./PriorityClients.vue?vue&type=script&lang=js&"
import style0 from "./PriorityClients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports